import { CHECK_USER_AUTH_SUCCESS, CHECK_USER_AUTH_ERROR, FETCH_USER_PROFILE_SUCCESS, FETCH_USER_PROFILE_ERROR, LOGOUT, FETCH_SOURCE_MAPPINGS, DEBUG_REMOVE_TOGGLE_THEME } from './actions';
import {Action, AnyAction, combineReducers} from 'redux';
import { RawUser } from './types';
import { success } from '@redux-requests/core';
import { LIGHT_THEME } from 'shared/constants';
import { DARK_THEME } from '../../shared/constants/themes';

const isUserAuthorized = (state = false, action:Action) => {
    const { type } = action;
  
    switch(type) {
    case CHECK_USER_AUTH_SUCCESS:
      return true;
    case CHECK_USER_AUTH_ERROR:
    case LOGOUT:
      return false;
    default:
      return state;
    }
  };
  
const profile = (state: Partial<RawUser> = {}, action: AnyAction) => {
    const { type, response } = action;
  
    switch(type) {
    case FETCH_USER_PROFILE_SUCCESS:
      return response;
    case LOGOUT:
      return null;
    case FETCH_USER_PROFILE_ERROR:
    default:
      return state;
    }
  };
   
const themeMode = (state: string = '', action: AnyAction) => {
    const { type, response } = action;
  
    switch(type) {
    case FETCH_USER_PROFILE_SUCCESS:
      return response.preferences.themeMode;
    case DEBUG_REMOVE_TOGGLE_THEME:
      const otherTheme = state === LIGHT_THEME ? DARK_THEME : LIGHT_THEME;

      return otherTheme;
    case FETCH_USER_PROFILE_ERROR:
    default:
      return state;
    }
  };
  
const sourceMappings = (state = null, action: AnyAction) => {
    const { type, response } = action;
  
    switch(type) {
    case success(FETCH_SOURCE_MAPPINGS):
      return response;
    default:
      return state;
  };
}
  
  export default combineReducers({
    isUserAuthorized,
    profile,
    sourceMappings,
    themeMode,
  });